// The public identity of the store, used by the <Seo> tags on every page.
//
// One build serves both the development and the production host, so whether a
// page may be indexed is decided at run time from the host name: only the
// production hosts are indexable, every other host (Cloudflare tunnel, a
// staging domain, localhost) gets "noindex, nofollow" on every page.

export const SITE_NAME = 'Rumah Kebijaksanaan';
export const SITE_URL = 'https://rumahkebijaksanaan.net';
export const SITE_DESCRIPTION =
  'Rumah Kebijaksanaan, toko buku online: cari dan beli buku pilihan, dukung program donasi buku, dan dapatkan komisi lewat program afiliasi.';
/** Shown when a page is shared on WhatsApp or social media (1200 x 630) */
export const SITE_IMAGE = `${SITE_URL}/og-image.png`;

const PRODUCTION_HOSTS = ['rumahkebijaksanaan.net', 'www.rumahkebijaksanaan.net'];

/** True on the production domain; false on dev, staging and localhost. */
export const isProductionHost = (hostname: string = window.location.hostname): boolean =>
  PRODUCTION_HOSTS.includes(hostname);

/** The canonical (production, non-www) address of a path such as `/store/book`. */
export const canonicalUrl = (path: string): string =>
  `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
